module["exports"] = [
  "#{city_prefix}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es_MX/address/city.js
 ** module id = 523
 ** module chunks = 0
 **/